import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { useCallback, useEffect } from 'react';

import { DefaultClass } from '../../models/DefaultClass';

interface IProps {
  submitting?: boolean;
  error: Error | null;
  onClose: () => void;
  onSubmit: (vehicleClass: DefaultClass) => void;
}

const VehicleClassModal: React.FC<IProps> = ({
  error,
  onClose,
  onSubmit,
  submitting,
}) => {
  const [form] = Form.useForm();

  const closeModal = useCallback(() => {
    form.resetFields();
    onClose();
  }, [form, onClose]);

  const submitModal = useCallback(
    (vehicleClass: DefaultClass) => {
      onSubmit(vehicleClass);
    },
    [onSubmit]
  );

  useEffect(() => {
    if (error) {
      notification.error({
        description: error.message,
        message: error.name,
      });
    }
  }, [error]);

  return (
    <Modal
      centered
      visible
      footer={null}
      maskClosable={false}
      title="Add Rate Class"
      width={400}
      onCancel={closeModal}
    >
      <Form form={form} layout="vertical" onFinish={submitModal}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Rate Class Name"
              name="name"
              rules={[{ message: 'Required', required: true }]}
            >
              <Input placeholder="Enter rate class name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item>
              <Button className="modal-close-btn" onClick={closeModal}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <Button
                className="modal-save-btn"
                htmlType="submit"
                loading={submitting}
                type="primary"
              >
                SAVE
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default VehicleClassModal;
